//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  gh: "가나",
  ga: "가봉",
  gy: "가이아나",
  gm: "감비아",
  gg: "건지",
  gp: "과들루프",
  gt: "과테말라",
  gu: "괌",
  gd: "그레나다",
  gr: "그리스",
  gl: "그린란드",
  gn: "기니",
  gw: "기니비사우",
  na: "나미비아",
  nr: "나우루",
  ng: "나이지리아",
  aq: "남극 대륙",
  ss: "남수단",
  za: "남아프리카",
  nl: "네덜란드",
  bq: "네덜란드령 카리브",
  np: "네팔",
  no: "노르웨이",
  nf: "노퍽섬",
  nz: "뉴질랜드",
  nc: "뉴칼레도니아",
  nu: "니우에",
  ne: "니제르",
  ni: "니카라과",
  tw: "대만",
  kr: "대한민국",
  dk: "덴마크",
  dm: "도미니카",
  do: "도미니카 공화국",
  de: "독일",
  tl: "동티모르",
  la: "라오스",
  lr: "라이베리아",
  lv: "라트비아",
  ru: "러시아",
  lb: "레바논",
  ls: "레소토",
  ro: "루마니아",
  lu: "룩셈부르크",
  rw: "르완다",
  ly: "리비아",
  re: "리유니온",
  lt: "리투아니아",
  li: "리히텐슈타인",
  mg: "마다가스카르",
  mq: "마르티니크",
  mh: "마셜 제도",
  yt: "마요트",
  mo: "마카오(중국 특별행정구)",
  mw: "말라위",
  my: "말레이시아",
  ml: "말리",
  im: "맨 섬",
  mx: "멕시코",
  mc: "모나코",
  ma: "모로코",
  mu: "모리셔스",
  mr: "모리타니",
  mz: "모잠비크",
  me: "몬테네그로",
  ms: "몬트세라트",
  md: "몰도바",
  mv: "몰디브",
  mt: "몰타",
  mn: "몽골",
  us: "미국",
  vi: "미국령 버진아일랜드",
  um: "미국령 해외 제도",
  mm: "미얀마",
  fm: "미크로네시아",
  vu: "바누아투",
  bh: "바레인",
  bb: "바베이도스",
  va: "바티칸 시국",
  bs: "바하마",
  bd: "방글라데시",
  bm: "버뮤다",
  bj: "베냉",
  ve: "베네수엘라",
  vn: "베트남",
  be: "벨기에",
  by: "벨라루스",
  bz: "벨리즈",
  ba: "보스니아 헤르체고비나",
  bw: "보츠와나",
  bo: "볼리비아",
  bi: "부룬디",
  bf: "부르키나파소",
  bv: "부베섬",
  bt: "부탄",
  mp: "북마리아나제도",
  mk: "북마케도니아",
  kp: "북한",
  bg: "불가리아",
  br: "브라질",
  bn: "브루나이",
  ws: "사모아",
  sa: "사우디아라비아",
  gs: "사우스조지아 사우스샌드위치 제도",
  sm: "산마리노",
  st: "상투메 프린시페",
  mf: "생마르탱",
  bl: "생바르텔레미",
  pm: "생피에르 미클롱",
  eh: "서사하라",
  sn: "세네갈",
  rs: "세르비아",
  sc: "세이셸",
  lc: "세인트루시아",
  vc: "세인트빈센트그레나딘",
  kn: "세인트키츠 네비스",
  sh: "세인트헬레나",
  so: "소말리아",
  sb: "솔로몬 제도",
  sd: "수단",
  sr: "수리남",
  lk: "스리랑카",
  sj: "스발바르제도-얀마웬섬",
  se: "스웨덴",
  ch: "스위스",
  es: "스페인",
  sk: "슬로바키아",
  si: "슬로베니아",
  sy: "시리아",
  sl: "시에라리온",
  sx: "신트마르턴",
  sg: "싱가포르",
  ae: "아랍에미리트",
  aw: "아루바",
  am: "아르메니아",
  ar: "아르헨티나",
  as: "아메리칸 사모아",
  is: "아이슬란드",
  ht: "아이티",
  ie: "아일랜드",
  az: "아제르바이잔",
  af: "아프가니스탄",
  ad: "안도라",
  al: "알바니아",
  dz: "알제리",
  ao: "앙골라",
  ag: "앤티가 바부다",
  ai: "앵귈라",
  er: "에리트리아",
  sz: "에스와티니",
  ee: "에스토니아",
  ec: "에콰도르",
  et: "에티오피아",
  sv: "엘살바도르",
  gb: "영국",
  vg: "영국령 버진아일랜드",
  io: "영국령 인도양 식민지",
  ye: "예멘",
  om: "오만",
  au: "오스트레일리아",
  at: "오스트리아",
  hn: "온두라스",
  ax: "올란드 제도",
  wf: "왈리스-푸투나 제도",
  jo: "요르단",
  ug: "우간다",
  uy: "우루과이",
  uz: "우즈베키스탄",
  ua: "우크라이나",
  iq: "이라크",
  ir: "이란",
  il: "이스라엘",
  eg: "이집트",
  it: "이탈리아",
  in: "인도",
  id: "인도네시아",
  jp: "일본",
  jm: "자메이카",
  zm: "잠비아",
  je: "저지",
  gq: "적도 기니",
  ge: "조지아",
  cn: "중국",
  cf: "중앙 아프리카 공화국",
  dj: "지부티",
  gi: "지브롤터",
  zw: "짐바브웨",
  td: "차드",
  cz: "체코",
  cl: "칠레",
  cm: "카메룬",
  cv: "카보베르데",
  kz: "카자흐스탄",
  qa: "카타르",
  kh: "캄보디아",
  ca: "캐나다",
  ke: "케냐",
  ky: "케이맨 제도",
  km: "코모로",
  cr: "코스타리카",
  cc: "코코스 제도",
  ci: "코트디부아르",
  co: "콜롬비아",
  cg: "콩고-브라자빌",
  cd: "콩고-킨샤사",
  cu: "쿠바",
  kw: "쿠웨이트",
  ck: "쿡 제도",
  cw: "퀴라소",
  hr: "크로아티아",
  cx: "크리스마스섬",
  kg: "키르기스스탄",
  ki: "키리바시",
  cy: "키프로스",
  tj: "타지키스탄",
  tz: "탄자니아",
  th: "태국",
  tc: "터크스 케이커스 제도",
  tr: "터키",
  tg: "토고",
  tk: "토켈라우",
  to: "통가",
  tm: "투르크메니스탄",
  tv: "투발루",
  tn: "튀니지",
  tt: "트리니다드 토바고",
  pa: "파나마",
  py: "파라과이",
  pk: "파키스탄",
  pg: "파푸아뉴기니",
  pw: "팔라우",
  ps: "팔레스타인 지구",
  fo: "페로 제도",
  pe: "페루",
  pt: "포르투갈",
  fk: "포클랜드 제도",
  pl: "폴란드",
  pr: "푸에르토리코",
  fr: "프랑스",
  tf: "프랑스 남부 지방",
  gf: "프랑스령 기아나",
  pf: "프랑스령 폴리네시아",
  fj: "피지",
  fi: "핀란드",
  ph: "필리핀",
  pn: "핏케언 섬",
  hm: "허드 맥도널드 제도",
  hu: "헝가리",
  hk: "홍콩(중국 특별행정구)",
};
